/**
 * Ambiente da aplicação (ADR-006): lido de /api/saude (AMBIENTE e marca do
 * banco). Alimenta a faixa visível em toda tela — "DEMONSTRAÇÃO — dados
 * fictícios", "HOMOLOGAÇÃO"… — e a regra do CNPJ fictício (aceito só em
 * desenvolvimento e teste, como no servidor). A produção não tem faixa.
 */
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { chamar } from './api.ts';

export interface Ambiente {
  ambiente: string;
  marca: string | null;
}
const Contexto = createContext<Ambiente | null>(null);

export const TEXTO_FAIXA: Record<string, string> = {
  demonstracao: 'DEMONSTRAÇÃO — dados fictícios',
  desenvolvimento: 'DESENVOLVIMENTO — dados fictícios',
  teste: 'TESTE — dados fictícios',
  homologacao: 'HOMOLOGAÇÃO',
  migracao: 'MIGRAÇÃO — ENSAIO',
};

/** Texto da faixa (null = sem faixa: produção). A marca do banco manda; sem ela, o AMBIENTE. */
export const textoFaixa = (a: Ambiente | null): string | null => {
  const chave = a?.marca ?? a?.ambiente;
  if (!chave || chave === 'producao') return null;
  return TEXTO_FAIXA[chave] ?? chave.toUpperCase();
};

export function ProvedorAmbiente({ children }: { children: ReactNode }) {
  const [a, setA] = useState<Ambiente | null>(null);
  useEffect(() => {
    chamar<Ambiente & { status: string }>('GET', '/api/saude', undefined, { silencioso: true })
      .then((r) => setA({ ambiente: r.ambiente, marca: r.marca ?? null }))
      .catch(() => setA({ ambiente: 'desconhecido', marca: null }));
  }, []);
  return <Contexto.Provider value={a}>{children}</Contexto.Provider>;
}

export function useAmbiente() {
  const a = useContext(Contexto);
  return { ambiente: a, faixa: textoFaixa(a), aceitarFicticio: a ? ['desenvolvimento', 'teste'].includes(a.ambiente) : false };
}

export function FaixaAmbiente() {
  const { faixa } = useAmbiente();
  if (!faixa) return null;
  return (
    <div className="faixa-ambiente" role="note" data-teste="faixa-ambiente">
      {faixa}
    </div>
  );
}
